export const MANUAL_QUALIFICATION_VALUE = "__manual__";

export const QUALIFICATION_GROUPS = [
  {
    label: "IT Profession",
    options: [
      "B.E Computer Science & Engineering (CSE)",
      "B.E Information Technology (IT)",
      "B.E Electronics & Communication Engineering (ECE)",
      "B.E Electrical & Electronics Engineering (EEE)",
      "B.E Electronics & Instrumentation Engineering (EIE)",
      "B.Tech Computer Science & Engineering (CSE)",
      "B.Tech Information Technology (IT)",
      "B.Tech Electronics & Communication Engineering (ECE)",
      "B.Tech Electrical & Electronics Engineering (EEE)",
      "M.Tech Computer Science & Engineering",
      "M.Tech Information Technology",
      "MCA (Master of Computer Applications)",
      "BCA (Bachelor of Computer Applications)",
      "B.Sc Computer Science",
      "Diploma in Computer Science / IT",
      "ITI — Computer Operator & Programming Assistant",
    ],
  },
  {
    label: "Robot Profession — Engineering",
    options: [
      "B.E Robotics & Automation",
      "B.E Mechatronics",
      "B.E Mechanical Engineering",
      "B.Tech Robotics & Automation",
      "B.Tech Mechatronics",
      "B.Tech Mechanical Engineering",
      "M.Tech Robotics",
      "M.Tech Mechatronics",
      "Diploma in Robotics",
      "Diploma in Mechatronics",
      "Industrial Automation Certification",
      "Certificate in Robotics Engineering",
    ],
  },
  {
    label: "Designers",
    options: [
      "B.Des (Bachelor of Design)",
      "M.Des (Master of Design)",
      "BFA (Bachelor of Fine Arts)",
      "Diploma in Graphic Design",
      "Diploma in UI/UX Design",
      "UI/UX Design Certification",
      "B.Arch (Bachelor of Architecture)",
      "Product Design Certification",
    ],
  },
];

export const ALL_LISTED_QUALIFICATIONS = QUALIFICATION_GROUPS.flatMap(
  (group) => group.options
);

export function resolveQualification(option, manualText, isManual = false) {
  if (isManual) {
    return manualText.trim();
  }
  return option.trim();
}

/** Maps a stored qualification string to dropdown + manual field state (edit forms). */
export function parseQualificationForEdit(qualification = "") {
  const trimmed = String(qualification).trim();
  if (!trimmed) {
    return { option: "", manual: "", isManual: false };
  }
  if (ALL_LISTED_QUALIFICATIONS.includes(trimmed)) {
    return { option: trimmed, manual: "", isManual: false };
  }
  return { option: "", manual: trimmed, isManual: true };
}
